import styled from 'styled-components'
import { Col } from 'react-styled-flexboxgrid'
import { ContentStyles } from '../base'
import variables from '../variables'


export const Container = styled(ContentStyles)`
  width: 100% !important;
  padding: 50px 0;
`

export const Title = styled.h1`
  margin-top: 0 !important;
`

export const Breadcrumb = styled.div`
  margin-bottom: 30px;

  @media ${variables.media.md} {
    margin-bottom: 0px;
  }
`

export const Endpoint = styled.div`
  &:not(:last-child) {
    margin-bottom: 5px;
  }
`

export const PaddedSpan = styled.span`
  padding: 0 10px;
`

export const TagCol = styled(Col)`
  padding-bottom: 50px;
`

export const TagHeader = styled.h6`
  font-size: 1rem !important;
  font-weight: 700 !important;
  color: #666;
  margin: 0 0 5px 0 !important;
`

export const TagText = styled.div`
  font-size: 1rem;
  margin-bottom: 20px;
`
